export default function UTitle({ text, className = '' }) {
  return (
    <h2
      className={`my-1 border-b-2 border-gray-accent text-lg font-bold text-black md:my-2 md:text-2xl ${className}`}
    >
      {text}
    </h2>
  )
}
